import { MeetingDurationType } from '@web/components/Filters/Elements/MeetingDurationType';
import { MeetingParticipantsType } from '@web/components/Filters/Elements/MeetingParticipantsType';
import { MeetingType } from '@web/components/Filters/Elements/MeetingType';
export var getIsRecurringOrScheduled = function (meetingType) {
    switch (meetingType) {
        case MeetingType.SCHEDULED:
            return {
                isScheduled: true,
                isRecurring: null
            };
        case MeetingType.NON_SCHEDULED:
            return {
                isScheduled: false,
                isRecurring: null
            };
        case MeetingType.RECURRING:
            return {
                isRecurring: true,
                isScheduled: null
            };
        case MeetingType.ONE_TIME:
            return {
                isRecurring: false,
                isScheduled: null
            };
        default:
            return {
                isRecurring: null,
                isScheduled: null
            };
    }
};
export var getDuration = function (meetingDurationType, durationHours, durationMinutes) {
    if (durationHours === 0 && durationMinutes === 0) {
        return {};
    }
    var durationSeconds = durationHours * 60 * 60 + durationMinutes * 60;
    switch (meetingDurationType) {
        case MeetingDurationType.ON_TIME_WITHIN:
            return {
                overrunDurationSecondsTo: durationSeconds
            };
        case MeetingDurationType.DURATION_LESS:
            return {
                durationSecondsTo: durationSeconds
            };
        case MeetingDurationType.DURATION_MORE:
            return {
                durationSecondsFrom: durationSeconds
            };
        case MeetingDurationType.OVERRUN_DURATION_LESS:
            return {
                overrunDurationSecondsTo: durationSeconds
            };
        case MeetingDurationType.OVERRUN_DURATION_MORE:
            return {
                overrunDurationSecondsFrom: durationSeconds
            };
        default:
            return {};
    }
};
export var getMeetingParticipantsType = function (meetingParticipantsType) {
    switch (meetingParticipantsType) {
        case MeetingParticipantsType.WITH_EXTERNAL_PARTICIPANTS:
            return {
                isExternalParticipants: true
            };
        case MeetingParticipantsType.WITH_INTERNAL_PARTICIPANTS:
            return {
                isExternalParticipants: false
            };
        default:
            return {
                isExternalParticipants: null
            };
    }
};
export var getFiltersMeetAdvancedSearch = function (filters) {
    var _a = getIsRecurringOrScheduled(filters.meetingType), isRecurring = _a.isRecurring, isScheduled = _a.isScheduled;
    var _b = getDuration(filters.meetingDurationType, filters.durationHours || 0, filters.durationMinutes || 0), durationSecondsFrom = _b.durationSecondsFrom, durationSecondsTo = _b.durationSecondsTo, overrunDurationSecondsFrom = _b.overrunDurationSecondsFrom, overrunDurationSecondsTo = _b.overrunDurationSecondsTo;
    var isExternalParticipants = getMeetingParticipantsType(filters.meetingParticipantsType).isExternalParticipants;
    var where = {
        dateFrom: filters.dateFrom,
        dateTo: filters.dateTo,
        userId: filters.user,
        orgUnitId: filters.user ? null : filters.orgUnit,
        title: filters.title || undefined,
        isRecurring: isRecurring,
        isScheduled: isScheduled,
        durationSecondsFrom: durationSecondsFrom,
        durationSecondsTo: durationSecondsTo,
        overrunDurationSecondsFrom: overrunDurationSecondsFrom,
        overrunDurationSecondsTo: overrunDurationSecondsTo,
        isExternalParticipants: isExternalParticipants
    };
    return where;
};
export var formatPersonWithOrgUnit = function (_a) {
    var name = _a.name, email = _a.email, orgUnitTitle = _a.orgUnitTitle, isExternal = _a.isExternal, externalLabel = _a.externalLabel;
    var displayName = name || email;
    if (isExternal) {
        return "".concat(displayName, " (").concat(externalLabel, ")");
    }
    if (orgUnitTitle) {
        return "".concat(displayName, " (").concat(orgUnitTitle, ")");
    }
    return displayName;
};
export var getMeetingTypeLabel = function (_a) {
    var isScheduled = _a.isScheduled, isRecurring = _a.isRecurring, labels = _a.labels;
    if (!isScheduled) {
        return labels.adHoc;
    }
    if (isRecurring) {
        return labels.scheduledRecurring;
    }
    return labels.scheduled;
};
/** Compact delta like "+12min" / "-10min" for the duration column. */
export var formatTimingDelta = function (timingDeltaSeconds) {
    var sign = timingDeltaSeconds > 0 ? '+' : '-';
    var absoluteMinutes = Math.max(1, Math.round(Math.abs(timingDeltaSeconds) / 60));
    return "".concat(sign).concat(absoluteMinutes, "min");
};
